export default __webpack_public_path__ + "static/media/672.05246831.png";